import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const ChevronRight20 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={20}
    contrast={contrast}
    className={className}
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M8.03033 16.5303L6.96967 15.4697L12.4393 9.99999L6.96967 4.53032L8.03033 3.46967L14.5607 9.99999L8.03033 16.5303Z'
      fill='currentColor'
    />
  </Svg>
);

ChevronRight20.displayName = 'ChevronRight20';
export default ChevronRight20;
